// extracted by mini-css-extract-plugin
module.exports = {"vertical-divider":"CouponTarget_vertical-divider_3Sla7","target-wrap":"CouponTarget_target-wrap_17SiG"};